<template>
    <div>
        <game-detail :details='details'></game-detail>
    </div>
</template>

<script>
import gameDetail from '../../components/gamedetail/gamedetail'

import logo_img from '../../images/xianlaigame/xl_gd.png'
import ercodeimg from '../../images/gamecenter_ercode/ercode_gd.png'
import list_img1 from '../../images/download/down-gd1.png'
import list_img2 from '../../images/download/down-gd2.png'
import list_img3 from '../../images/download/down-gd3.png'
import cut_img1 from '../../images/download/cut_gd1.jpg'
import cut_img2 from '../../images/download/cut_gd2.jpg'
import cut_img3 from '../../images/download/cut_gd3.jpg'
export default {
    data(){
        return{
            details:{
                logo_img:logo_img,
                name:'闲来广东麻将',
                size:'69.64',
                load_count:'2250',
                desp:'"您玩过广东麻将么？什么，没有？来来来！快跟我一起搓两把，保证您深深的爱上广东麻将！ 广东麻将历史悠久，上手简单，深受广大麻友的喜爱。它的玩法多样，趣味性十足，有家喻户晓的推倒胡、鸡平胡，还有深受麻友喜爱的鬼牌、买马等一系列趣味的玩法，让游戏玩法更加的多样。"',
                ios_url:'http://app6.auwvnd.cn/?downloadfrom=guangdong',
                android_url:'http://app6.auwvnd.cn/?downloadfrom=guangdong',
                ercodeimg:ercodeimg,
                list_img1:list_img1,
                list_img2:list_img2,
                list_img3:list_img3,
                cut_img1:cut_img1,
                cut_img2:cut_img2,
                cut_img3:cut_img3
            }
        }
    },
    components:{
        gameDetail
    }
}
</script>

<style scoped>

</style>
